<template>
    <div class="header">
        <b-row class="w-100">
            <b-col class="d-flex" order="2" order-lg="1" order-xl="1">
                <slot name="left">
                    <div
                        class="go-back-button"
                        @click="onClickGoBackToDashboardsPanel"
                    >
                        <i class="fas fa-chevron-left mr-1" />
                        <span>{{
                            $t('reports.dashboards.goBackToDashboardsPanel')
                        }}</span>
                    </div>
                </slot>
            </b-col>
            <b-col
                order="1"
                order-lg="2"
                order-xl="2"
                sm="12"
                lg="8"
                xl="8"
                class="d-flex justify-content-center mb-2 mb-lg-0 mb-xl-0"
            >
                <slot name="center" />
            </b-col>
            <b-col order="3" class="d-flex justify-content-end">
                <slot name="right">
                    <b-button
                        v-show="showRightButton"
                        size="sm"
                        variant="white"
                        class="right-button"
                        @click="$emit('clickRightButton')"
                        >{{ rightButtonText }}</b-button
                    >
                </slot>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        showRightButton: {
            type: Boolean,
            default: true,
        },
        rightButtonText: String,
    },
    methods: {
        onClickRightButton() {
            this.$emit('clickRightButton')
        },
        onClickGoBackToDashboardsPanel() {
            this.$router.push('/v2/reports/list')
        },
    },
}
</script>
<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    min-height: 84px;
    max-height: 100px;
    margin-bottom: 37px;
    padding: 10px;
    border-bottom: 1px solid #bec0c0;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

    .right-button {
        animation-name: fadeIn;
        animation-duration: 0.3s;
        align-self: center;
        float: right;
        color: white;
        width: 80px;
        background-color: #022b4f;
    }

    .go-back-button {
        align-self: center;
        cursor: pointer;
        font-size: 12px;
        color: #6e6e6e;
    }
}
</style>
